//
import React from "react";
import { useTranslation } from "react-i18next";

import img_hq from "../assets/images/widepack-hq.png";
import "../scss/Location.scss";

export const Location = () => {
  const { t } = useTranslation();
  return (
    <main className='location'>
      <div className='container'>
        <div className='grid-location'>
          <div className='map'>
            <iframe
              src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2507.3796215720495!2d4.5349177159961656!3d51.064541950806564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c3e55b07ce601f%3A0xfcc2a774819d17b5!2sWidePack!5e0!3m2!1sen!2sbe!4v1665040174369!5m2!1sen!2sbe'
              width='100%'
              height='100%'
              style={{ border: 0 }}
              allowfullscreen=''
              loading='lazy'
              referrerpolicy='no-referrer-when-downgrade'
            ></iframe>
          </div>

          <div className='street'>
            <iframe
              src='https://www.google.com/maps/embed?pb=!4v1665046658985!6m8!1m7!1s7wWcr1Pg-ZQaOtZqI81M7g!2m2!1d51.06455360170695!2d4.53669340586301!3f115.48201!4f0!5f0.7820865974627469'
              width='100%'
              height='100%'
              style={{ border: 0 }}
              allowfullscreen=''
              loading='lazy'
              referrerpolicy='no-referrer-when-downgrade'
            ></iframe>
          </div>

          <div className='card_hq hq'>
            <div className='card_title'>
              <h1>WidePack HQ</h1>
            </div>

            <div className='card_content'>
              <div className='card_address'>
                <span> Dreefvelden 56 a, </span>
                <br />
                <span> 2860 Sint-Katelijne-Waver, </span>
                <br />
                <span> Antwerp Belgium </span>
                <br />
              </div>

              <div className='card_vat'>
                <span> BE 0881 216 096 </span>
                <br />
              </div>

              <div className='card_img'>
                <img src={img_hq} alt='Avatar' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};
